import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { AuthContext } from '../../Context/AuthContext';
import useRequestHandler from './../useRequestHandler';

const useDeleteCompanyPrivacyPolicy = () => {

    const { t } = useTranslation();
    const { acquireTokenSilently, apiClient } = useContext(AuthContext);
    const { errorHandler, successHandler } = useRequestHandler();
    
    /** Delete company privacy policy */
    const deleteCompanyPrivacyPolicy = async () => {
        try {

            const accessToken = await acquireTokenSilently();

            if (accessToken === "login_required") throw Error("login_required");

            const result = await apiClient.delete(accessToken, "company/privacypolicy");

            return successHandler(result, "useDeleteCompanyPrivacyPolicy", "delete", { message: t('success.companyPrivacyPolicyDeletedSuccesfully') });

        } catch (error) {
            return errorHandler(error, "useDeleteCompanyPrivacyPolicy", "delete");
        }
    }

    return { deleteCompanyPrivacyPolicy };

}

export default useDeleteCompanyPrivacyPolicy;
